import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';

const STORAGE_PREFIX = 'idem_';

function createFingerprint(req: HttpRequest<any>): string {
  const body = req.body ? JSON.stringify(req.body) : '';
  const str = `${req.method}|${req.urlWithParams}|${body}`;
  return btoa(encodeURIComponent(str));
}

export const idempotencyInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {

  if (!['POST', 'PUT', 'PATCH'].includes(req.method)) {
    return next(req);
  }
  if (req.body instanceof FormData) {
    return next(req);
  }

  const fingerprint = createFingerprint(req);
  const storageKey  = STORAGE_PREFIX + fingerprint;
  const existingKey = sessionStorage.getItem(storageKey);

  if (existingKey) {
    // Key exists in sessionStorage  same request already sent  BLOCK IT
    console.warn(`[Idempotency] Duplicate blocked — key already in session: ${req.urlWithParams}`);
    return EMPTY; // no network call, silent complete
  }
  const idempotencyKey = crypto.randomUUID();
  sessionStorage.setItem(storageKey, idempotencyKey);
  return next(req).pipe(
    finalize(() => {
      const stillExists = sessionStorage.getItem(storageKey);
      if (stillExists) {
        sessionStorage.removeItem(storageKey);
      }
    })
  );
};